import { isObject } from './is-object.js';
import { isUnknownArray } from './is-unknown-array.js';

export function isUnknownObject(value: unknown): value is UnknownObject {
  return isObject(value) && !isUnknownArray(value);
}
